import { getBaseQuery, getBaseUrl, REQUEST_TIMEOUT_MS } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import { BasicOptionResponse, UserOptionListRequest } from './option-api.def.ts'

const interfaceName = 'option'

export const optionApi = createApi({
  reducerPath: 'optionApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName), REQUEST_TIMEOUT_MS),
  tagTypes: ['option'],
  endpoints: (build) => ({
    listFirmOptions: build.query<BasicOptionResponse, void>({
      query: () => ({
        url: '/firm',
        method: 'GET',
      }),
    }),
    listUserOptions: build.query<BasicOptionResponse, UserOptionListRequest>({
      query: (params) => ({
        url: '/user/',
        method: 'GET',
        params: params,
      }),
    }),
    listGroupOptions: build.query<BasicOptionResponse, string>({
      query: (firmId) => ({
        url: `/group/${firmId}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useListFirmOptionsQuery,
  useListUserOptionsQuery,
  useListGroupOptionsQuery,
} = optionApi
